const costCenterLoading = {
  loadingChargesHeader: {
    'Vehicle Name': 'vehicle_short_form',
    Movement: 'movement',
    'Depot REF ID': 'ref_id',
    'Loading cost': 'loading_cost',
    'Unloading cost': 'unloading_cost',
    'ODA cost': 'oda_cost',
    Unit: 'unit',
  },
};
module.exports = { costCenterLoading };
